/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .kt-aside[_ngcontent-%COMP%]{height:100%}[_nghost-%COMP%]   .kt-aside[_ngcontent-%COMP%]   .kt-aside-menu[_ngcontent-%COMP%]{margin:0}[_nghost-%COMP%]   .kt-menu__link-text[_ngcontent-%COMP%]{white-space:nowrap}"];
export { styles as styles };
